import { Clock } from '@phosphor-icons/react'
import { AnimatePresence, motion } from 'framer-motion'
import { useMemo, useState } from 'react'
import { REGIONS, TOURS, formatUSD } from '../data/travel'

const FILTERS = ['Todos', ...REGIONS]

export default function Tours() {
  const [filter, setFilter] = useState('Todos')
  const list = useMemo(
    () => (filter === 'Todos' ? TOURS : TOURS.filter((t) => t.region === filter)),
    [filter],
  )

  return (
    <section id="tours" className="scroll-mt-16 bg-white px-4 py-20 md:px-8 md:py-28">
      <div className="mx-auto max-w-7xl">
        <p className="mb-3 text-xs font-semibold uppercase tracking-[0.18em] text-sunset-600">Desde Guatemala</p>
        <h2 className="max-w-2xl font-display text-3xl font-extrabold tracking-tight text-navy-950 md:text-5xl">
          Tours con precio real, no promesa.
        </h2>
        <p className="mt-4 max-w-[60ch] text-base leading-relaxed text-navy-700/60">
          Precio por persona. Excursiones y experiencias listas para reservar, sin sorpresas.
        </p>

        <div className="-mx-4 mt-8 flex gap-2 overflow-x-auto px-4 pb-1 [scrollbar-width:none] md:mx-0 md:flex-wrap md:px-0">
          {FILTERS.map((f) => (
            <button
              key={f}
              type="button"
              onClick={() => setFilter(f)}
              className={`shrink-0 rounded-xl px-4 py-2 text-sm font-semibold transition-colors ${
                filter === f ? 'bg-navy-950 text-white' : 'bg-navy-50 text-navy-700/60 hover:text-navy-950'
              }`}
            >
              {f}
            </button>
          ))}
        </div>

        <motion.ul layout className="mt-8 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4">
          <AnimatePresence initial={false}>
            {list.map((t) => (
              <motion.li
                key={t.slug}
                layout
                initial={{ opacity: 0, scale: 0.97 }}
                animate={{ opacity: 1, scale: 1 }}
                exit={{ opacity: 0, scale: 0.97 }}
                transition={{ duration: 0.35, ease: [0.16, 1, 0.3, 1] }}
              >
                <a
                  href={`https://wa.me/50239990332?text=${encodeURIComponent(`Hola, quiero más información sobre: ${t.title}`)}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="group block overflow-hidden rounded-2xl bg-navy-50 transition-shadow duration-300 hover:shadow-[0_18px_40px_rgba(14,20,32,0.12)]"
                >
                  <div className="relative aspect-[4/3] overflow-hidden">
                    <img
                      src={t.image}
                      alt={t.title}
                      className="size-full object-cover transition-transform duration-700 group-hover:scale-[1.05]"
                    />
                    {t.badge && (
                      <span className="absolute left-3 top-3 rounded-xl bg-white px-2.5 py-1 text-xs font-semibold text-navy-950">
                        {t.badge}
                      </span>
                    )}
                  </div>
                  <div className="p-4">
                    <div className="flex items-start justify-between gap-3">
                      <div>
                        <h3 className="font-display text-lg font-bold leading-tight text-navy-950">{t.title}</h3>
                        <p className="text-sm text-navy-700/60">{t.place}</p>
                      </div>
                      <span className="inline-flex items-center gap-1 text-xs font-medium text-navy-700/60">
                        <Clock size={13} weight="fill" />
                        {t.duration}
                      </span>
                    </div>
                    <p className="mt-3 text-sm text-navy-700/60">
                      desde <span className="font-display text-xl font-extrabold text-navy-950">{formatUSD(t.price)}</span>
                    </p>
                  </div>
                </a>
              </motion.li>
            ))}
          </AnimatePresence>
        </motion.ul>
      </div>
    </section>
  )
}
